import React, { useState, useEffect } from "react";
import StorefrontTitle from "../shared/storefront-title.component";
import FirebaseAnalytics from "../../services/analytics.service";
// import BillPaymentBills from "../views/bill-payment/bill-payment-bills";
import Translation from "../../services/translation.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import Settings from "../../services/settings.service";
import CommonPaymentSuccessIcon from "../../assets/img/payment-success.svg";

export default function BillPaymentCheckLinkUI(props) {
    const { history } = props;
    const [loader, setLoader] = useState(true);
    const [hasUnpaidBills, setHasUnpaidBills] = useState(false);

	useEffect(() => {
        setLoader(false);
		window.scrollTo({ top: 0, behavior: "smooth" });
        if (history?.location?.state && history?.location?.state?.hasUnpaidBills) {
            const hasUnpaidBills = history?.location?.state?.hasUnpaidBills;
            setHasUnpaidBills(hasUnpaidBills)
            if(hasUnpaidBills) {
                const firebase_event_params = {
                    event_category: 'bills',
                    event_screen: 'bills_link_sent',
                    interaction_type: 'view',
                    event_label: 'screen'
                }
                FirebaseAnalytics.commonFunction(firebase_event_params);
            } else {
                const firebase_event_params = {
                    event_category: 'bills',
                    event_screen: 'no_pending_bills',
                    interaction_type: 'view',
                    event_label: 'screen'
                }
                FirebaseAnalytics.commonFunction(firebase_event_params);
            }
        }
	}, []) // eslint-disable-line react-hooks/exhaustive-deps
    
    const cancelProcess = () => {
        setLoader(true);
        localStorage.clear();
        const firebase_event_params = {
            event_category: 'bills',
            event_screen: 'bill_success',
            interaction_type: 'click',
            event_label: 'go_to_homepage'
        }
        FirebaseAnalytics.commonFunction(firebase_event_params);
        setTimeout(() => {
            window.location.href = Settings.site_link;
        }, 1000);
    }

	return (
        loader ? <SpinnerTimeLoader /> :
        <>
        {hasUnpaidBills ?
            <>
                <div className="stm-topup-info-container bill-payment-check-link">
                <div>
                    <StorefrontTitle
                    title={Translation.keys["stm_bill_payment_link_sent_heading"] || "We’ve sent an SMS with the payment link to the mobile number linked to your Civil ID"}
                    desc={Translation.keys["stm_bill_payment_link_sent_desc"] || "We have sent you an sms with the payment link to the mobile number registered on the Civil ID provided. Please check for the SMS and complete the payment."}
                    />
                </div>
                <div className="topup-field-wrapper">
                    <div className="topup-btn-section">
                    <button
                        className="common-button"
                        type="button"
                        onClick={() => { cancelProcess() }}
                    >
                        {Translation.keys["stf_go_home"] || "Go to Home"}
                    </button>
                    </div>
                </div>
                </div>
            </> :
            <>
                <div className="stm-topup-info-container bill-payment-check-link">
                    <div className="success-img">
                        <img src={CommonPaymentSuccessIcon} alt="" />
                    </div>
                    <div>
                        <StorefrontTitle
                        title={Translation.keys["stm_bill_payment_no_bill_heading"] || "No Pending Bills"}
                        desc={Translation.keys["stm_bill_payment_no_bill_desc"] || "This customer currently has no accounts with outstanding balances"}
                        />
                    </div>
                    <div className="topup-field-wrapper">
                        <div className="topup-btn-section">
                        <button
                            className="common-button"
                            type="button"
                            onClick={() => { cancelProcess() }}
                        >
                            {Translation.keys["stf_go_home"] || "Go to Home"}
                        </button>
                        </div>
                    </div>
                </div>
            </>
        }
        </>
	)
}